import { Dispatch, SetStateAction } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Say } from "../../../languages";

type Props = {
  visible?: boolean;
  emailAddress: string;
  orderId: string;
  toggleBoothComplete: Dispatch<SetStateAction<boolean>>;
};

const OrderConfirmationBoothComplete = ({
  visible = true,
  emailAddress,
  orderId,
  toggleBoothComplete
}: Props) => {
  if (!visible) return null;

  return (
    <div className="order-confirmation__booth-complete">
      <div className="order-confirmation__booth-complete-message">
        <span className="order-confirmation__complete-icon">
          <FontAwesomeIcon icon={faCircleCheck} />
        </span>
        <p className="zeta">
          <strong>
            <Say phrase="chosen.thank_you.confirmation_heading" />
          </strong>
        </p>
      </div>

      <div className="order-confirmation__booth-complete-details">
        <strong className="order-confirmation__booth-complete-title">
          <Say
            phrase="chosen.thank_you.order_number"
            mutator={(value) => value.replace("{{orderId}}", orderId)}
          />
        </strong>
        <p>
          <Say phrase="chosen.thank_you.confirmation_email" /> <strong>{emailAddress}</strong>
        </p>

        <a
          data-target="internal_link"
          data-info={`chosen.thank_you.back_to_qr_cta:${window.location.href}`}
          data-type="button"
          onClick={() => toggleBoothComplete(false)}>
          <Say phrase="chosen.thank_you.back_to_qr_cta" />
        </a>
      </div>
    </div>
  );
};

export default OrderConfirmationBoothComplete;
